@use '../../styling/colors.scss' as *;

.ColorCard {
  // Make a fake border since the SVG background will not fill to meet all edges
  box-shadow: 0 0 0 1px inset;
  height: 100%;
  width: 100%;
  border-radius: 6px;

  &.lightPurple {
    box-shadow: 0 0 0 1px inset $color-action-snippetenabled;
  }

  &.darkPurple {
    box-shadow: 0 0 0 1px inset $color-action-submodel;
  }

  &.blue {
    box-shadow: 0 0 0 1px inset $color-state-default;
  }

  &.darkBlue {
    box-shadow: 0 0 0 1px inset $color-action-exit;
  }

  &.lightBlue {
    box-shadow: 0 0 0 1px inset $color-action-back;
  }

  &.lightGray {
    box-shadow: 0 0 0 1px inset $color-action-default;
  }

  &.inputFieldBorderGray {
    box-shadow: 0 0 0 1px inset $theme-color-form-control-border;
  }

  &.orange {
    box-shadow: 0 0 0 1px inset $color-warning-orange;
  }

  &.violet {
    box-shadow: 0 0 0 1px inset $color-state-global;
  }

  &.green {
    box-shadow: 0 0 0 1px inset $color-state-initial;
  }

  &.red {
    box-shadow: 0 0 0 1px inset $color-primary-red;
  }
}
